export default function parseUnderline(xmlNode) {
  return {
    type: "text",
    text: xmlNode.textContent,
    marks: [{ type: "underline" }],
  };
}
